<template>
  <div class="log-item-wrap">
    <div class="log-item-content">
      <div>{{logItem.content}}</div>
      <lk-icon type="ios-arrow-dropdown" class="log-item-button" @click="toggleExpand" v-if="logItem.children && logItem.children.length"/>
    </div>
    <div class="log-item-children-wrap" v-if="logItem.children && logItem.children.length && expand" >
      <div v-for="(item,index) in logItem.children" :key="index">
        {{item.content}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'logItem',
  props: {
    logItem: {
      type: Object,
    },
  },
  data() {
    return {
      expand: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expand = !this.expand;
    },
  },
};
</script>
<style lang="less" scoped>
.log-item-wrap{
  .log-item-content{
    font-size: 14px;
    display: flex;
    align-items: center;
    line-height: 20px;
    margin-bottom: 5px;
    .log-item-button{
      cursor: pointer;
    }
  }
  .log-item-children-wrap{
    word-break: break-all;
    padding: 16px;
    font-size: 14px;
    background-color:  #F5F5F5;
  }
}
</style>
